<div class="card card-info card-outline">
    <div class="card-header">
        <h3 class="card-title headText1"><i class="fas fa-city"></i> ข้อมูลฝ่าย</h3>
        <div class="card-tools text-primary ">
          <button type="button" class="btn btn-tool" data-card-widget="collapse">
            <i class="fas fa-minus"></i>
          </button>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
            <div class="col-4">
                <form #frm_addFac="ngForm"
                    (ngSubmit)="saveAddFaction(frm_addFac.value); formFacReset()"novalidate>
                    <div class="card card-primary card-outline">
                        <div class="card-header">
                            <h3 class="card-title text-primary"><i class="fas fa-plus-circle"></i> เพิ่มข้อมูลฝ่าย</h3>
                        </div>
                        <div class="card-body">
                                <div class="form-group row">
                                    <label for="dep_id" class="col-sm-2 col-form-label">รหัสฝ่าย</label>
                                    <div class="col-sm-10">
                                        <input #faction="ngModel" ngModel name="faction" class="form-control" placeholder="ป้อนรหัสฝ่าย2หลัก"
                                        required [ngClass]="{ 'is-invalid' : faction.invalid && (faction.dirty || faction.touched )}"
                                        minlength="2" maxlength="2" (keypress)="numberOnly($event)"
                                        [(ngModel)]="facEdit.faction">
                                        <div class="invalid-feedback">
                                            <span *ngIf="faction.hasError('required')">กรุณาป้อนรหัสฝ่าย2หลัก</span>
                                            <span *ngIf="faction.hasError('minlength')">กรุณาป้อนรหัสฝ่าย2หลัก</span>
                                            <span *ngIf="faction.hasError('maxlength')">กรุณาป้อนรหัสฝ่าย2หลัก</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="faction_name" class="col-sm-2 col-form-label">ชื่อฝ่าย</label>
                                    <div class="col-sm-10">
                                        <input #faction_name="ngModel" ngModel name="faction_name" class="form-control" placeholder="ป้อนชื่อแผนก"
                                        required [ngClass]="{ 'is-invalid' : faction_name.invalid && (faction_name.dirty || faction_name.touched )}"
                                        [(ngModel)]="facEdit.faction_name">
                                        <div class="invalid-feedback">
                                            <span *ngIf="faction_name.hasError('required')">กรุณาป้อนชื่อฝ่าย</span>
                                        </div>
                                    </div>
                                </div>
                                <input #dataid="ngModel" ngModel name="dataid" type="hidden" [(ngModel)]="facEdit.dataid">
                        </div>
                        <div class="card-footer">
                            <div class="btn-group btn-group-md">
                                <button type="submit" class="btn btn-info" 
                                    [disabled]="frm_addFac.invalid || formFacEdit">เพิ่มข้อมูล</button>
                                <button (click)="saveEditFac(frm_addFac.value)" 
                                    type="button" class="btn btn-warning ml-1" 
                                    *ngIf="formFacEdit">แก้ไขข้อมูล</button>
                                <button (click)="delFaction(dataid.value)" type="button" class="btn btn-danger ml-1" 
                                    *ngIf="formFacEdit">ลบข้อมูล</button> 
                                <button (click)="formFacReset()" type="reset" class="btn btn-secondary ml-1">กรอกใหม่</button> 
                            </div>
                        </div>
                    </div>
                </form>
                <!-- {{ frm_addFac.value | json }} -->
            </div>
            <div class="col-8">
                <div class="card card-primary card-outline">
                    <div class="card-header">
                        <h3 class="card-title text-primary"><i class="fas fa-warehouse"></i> ข้อมูลฝ่าย</h3>
                        <button (click)="factionList()" type="button" class="btn btn-link" data-toggle="tooltip" title="Refresh">
                            <i class="fa fa-rotate-right"></i></button>
                        <div class="card-tools">
                            <!-- <span data-toggle="tooltip" title="3 New Messages" class="badge bg-primary">3</span> -->
                            <button (click)="factionList()" type="button" class="btn btn-tool" data-toggle="tooltip" title="Refresh">
                                <i class="	fas fa-circle-notch"></i></button>
                            <button (click)="exportExcel()" type="button" class="btn btn-tool" data-toggle="tooltip" title="Download Excel">
                                    <i class="	fas fa-file-excel"></i></button>
                            <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-minus"></i>
                            </button>
                        </div>
                    </div>
                    <div class="card-body table-responsive p-2" style="height: 300px">
                        <table #tb_faction class="table table-hover table-head-fixed text-nowrap" id="faction-table">
                            <thead>
                                <tr class="text-primary">
                                    <th>รหัสฝ่าย</th>
                                    <th>ชื่อฝ่าย</th>
                                    <th class="text-center"><i class="fas fa-bars"></i></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr (click)="editFac(item.dataid)" *ngFor="let item of factionData">
                                    <td>{{ item.faction }}</td>
                                    <td>{{ item.faction_name }}</td>
                                    <!-- <td [ngClass]="[ item.schedule==1 && item.status_sv !=5 ? 'bg-warning align-middle' : 'align-middle' ]">{{ item.date_schedule | adtob }}</td> -->
                                    <td class="text-center text-primary align-middle">
                                        <a (click)="modalUpdataaudit(item.dataid)" data-bs-toggle="modal"
                                            data-bs-target="#explan_plant">
                                            <i class="fas fa-edit"></i>
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
      </div>
</div>

<div class="card card-info card-outline">
    <div class="card-header">
        <h3 class="card-title headText1"><i class="fas fa-clone"></i> ข้อมูลส่วน</h3>
        <div class="card-tools text-primary ">
          <button type="button" class="btn btn-tool" data-card-widget="collapse">
            <i class="fas fa-minus"></i>
          </button>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
            <div class="col-4">
                <form #frm_addPart="ngForm"
                    (ngSubmit)="saveAddPart(frm_addPart.value); formPartReset()"novalidate>
                    <div class="card card-primary card-outline">
                        <div class="card-header">
                            <h3 class="card-title text-primary"><i class="fas fa-plus-circle"></i> เพิ่มข้อมูลส่วน</h3>
                        </div>
                        <div class="card-body">
                                <div class="form-group row">
                                    <label for="partcode" class="col-sm-2 col-form-label">รหัสส่วน</label>
                                    <div class="col-sm-10">
                                        <input #partcode="ngModel" ngModel name="partcode" class="form-control" placeholder="ป้อนรหัสส่วน2หลัก"
                                        required [ngClass]="{ 'is-invalid' : partcode.invalid && (partcode.dirty || partcode.touched )}"
                                        minlength="2" maxlength="2" (keypress)="numberOnly($event)"
                                        [(ngModel)]="partEdit.partcode">
                                        <div class="invalid-feedback">
                                            <span *ngIf="partcode.hasError('required')">กรุณาป้อนรหัสส่วน2หลัก</span>
                                            <span *ngIf="partcode.hasError('minlength')">กรุณาป้อนรหัสส่วน2หลัก</span>
                                            <span *ngIf="partcode.hasError('maxlength')">กรุณาป้อนรหัสส่วน2หลัก</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="partname" class="col-sm-2 col-form-label">ชื่อส่วน</label>
                                    <div class="col-sm-10">
                                        <input #partname="ngModel" ngModel name="partname" class="form-control" placeholder="ป้อนชื่อส่วน"
                                        required [ngClass]="{ 'is-invalid' : partname.invalid && (partname.dirty || partname.touched )}"
                                        [(ngModel)]="partEdit.partname">
                                        <div class="invalid-feedback">
                                            <span *ngIf="partname.hasError('required')">กรุณาป้อนชื่อส่วน</span>
                                        </div>
                                    </div>
                                </div>
                                <input #dataid="ngModel" ngModel name="dataid" type="hidden" [(ngModel)]="partEdit.dataid">
                        </div>
                        <div class="card-footer">
                            <div class="btn-group btn-group-md">
                                <button type="submit" class="btn btn-info" 
                                    [disabled]="frm_addPart.invalid || formPartEdit">เพิ่มข้อมูล</button>
                                <button (click)="saveEditPart(frm_addPart.value)" 
                                    type="button" class="btn btn-warning ml-1" 
                                    *ngIf="formPartEdit">แก้ไขข้อมูล</button>
                                <button (click)="delPart(frm_addPart.value)" type="button" class="btn btn-danger ml-1" 
                                    *ngIf="formPartEdit">ลบข้อมูล</button> 
                                <button (click)="formPartReset()" type="reset" class="btn btn-secondary ml-1">กรอกใหม่</button> 
                            </div>
                        </div>
                    </div>
                </form>
                <!-- {{ frm_addPart.value | json }} -->
            </div>
            <div class="col-8">
                <div class="card card-primary card-outline">
                    <div class="card-header">
                        <h3 class="card-title text-primary"><i class="fas fa-warehouse"></i> ข้อมูลส่วน</h3>
                        <button (click)="partList()" type="button" class="btn btn-link" data-toggle="tooltip" title="Refresh">
                            <i class="fa fa-rotate-right"></i></button>
                        <div class="card-tools">
                            <!-- <span data-toggle="tooltip" title="3 New Messages" class="badge bg-primary">3</span> -->
                            <button (click)="partList()" type="button" class="btn btn-tool" data-toggle="tooltip" title="Refresh">
                                <i class="	fas fa-circle-notch"></i></button>
                            <button (click)="exportExcel()" type="button" class="btn btn-tool" data-toggle="tooltip" title="Download Excel">
                                    <i class="	fas fa-file-excel"></i></button>
                            <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-minus"></i>
                            </button>
                        </div>
                    </div>
                    <div class="card-body table-responsive p-2" style="height: 300px">
                        <table #tb_part class="table table-hover table-head-fixed text-nowrap" id="part-table">
                            <thead>
                                <tr class="text-primary">
                                    <th>#</th>
                                    <th>รหัสส่วน</th>
                                    <th>ชื่อส่วน</th>
                                    <th class="text-center"><i class="fas fa-bars"></i></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr (click)="editPart(item.dataid)" *ngFor="let item of partData;let i = index">
                                    <td>{{ i+1 }}</td>
                                    <td>{{ item.partcode }}</td>
                                    <td>{{ item.partname }}</td>
                                    <!-- <td [ngClass]="[ item.schedule==1 && item.status_sv !=5 ? 'bg-warning align-middle' : 'align-middle' ]">{{ item.date_schedule | adtob }}</td> -->
                                    <td class="text-center text-primary align-middle">
                                        <a (click)="modalUpdataaudit(item.dataid)" data-bs-toggle="modal"
                                            data-bs-target="#explan_plant">
                                            <i class="fas fa-edit"></i>
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
      </div>
</div>

